import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loadPageData } from "redux/actions/Request";

import moment from "moment-timezone";

import { pageWithPayloadAndQuery } from "redux/actions/Page";

import { WILDCARD_ORG_ID } from "lib/api/API";

import { Org } from "lib/models/Org";
import { User } from "lib/models/User";
import { Location } from "lib/models/Location";
import Request from "lib/api/Request";
import _ from "lodash";

import UsersPageView2 from "./UsersPageView2";
import { LocationsComponent } from "./LocationsPageView";
import { OrganizationComponent, EditOrgDialog } from "./OrganizationPageView";

import SimpleTable from "views/Components/SimpleTable";

import { renderConfigCell } from "views/Components/MSP/helpers";
import { roleConstantsSelector } from "../../selectors/roleConstantsSelector";

import AddCircleIcon from "@material-ui/icons/AddCircle";
import DetailsIcon from "@material-ui/icons/ZoomIn";

const OrganizationDetail = (props) => {
  const { timezones, orgs, orgsError, handleDeleteDone, orgId, routeToPage } =
    props;

  return (
    <div className="organizations-detail-page">
      <div className="dashboard-table">
        <OrganizationComponent
          org={[orgs.find((o) => o.id === orgId)]}
          ready={props.ready}
          orgsError={orgsError}
          orgId={orgId}
          loadPageData={loadPageData}
          timezones={timezones}
          handleDeleteDone={handleDeleteDone}
          sessionOrgId={orgId}
          superadmin={!!props.superadmin}
          isAdministeringOrg={!!props.isAdministeringOrg}
        />
      </div>

      <div className="dashboard-table">
        <LocationsComponent
          locations={props.locations}
          ready={props.ready}
          orgId={orgId}
          timezones={timezones}
        />
      </div>

      <div className="dashboard-table">
        <UsersPageView2 locations={props.locations} routeToPage={routeToPage} />
      </div>
    </div>
  );
};

const OrganizationsPageView = (props) => {
  const [openForm, setOpenForm] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [selectedOrgModel, setSelectedOrgModel] = useState(false);
  const [locationModel, setLocationModel] = useState(false);
  const [userModel, setUserModel] = useState(false);
  const [totalAgents, setTotalAgents] = useState({});

  const {
    currentUserId,
    timezones,
    user,
    orgs,
    orgsError,
    gotoOrg,
    payload,
    roleConstants,
    locations,
    routeToPage,
  } = props;

  useEffect(() => {
    const totalAgentsRequest = new Request("/lcagent");

    totalAgentsRequest.get().then((allAgents) => {
      const totalAgentsByOrg = _(allAgents)
        .countBy((agent) => agent.orgId)
        .value();
      setTotalAgents(totalAgentsByOrg);
    });
  }, [orgs]);

  const renderDateCell = (column, model) => {
    const timeValue = model[column.field];
    if (!timeValue) {
      return "Pending";
    }
    return moment.utc(timeValue).tz(moment.tz.guess(true)).format("lll z");
  };

  const tableColumns = [
    {
      title: "Name",
      field: "name",
      searchable: true,
    },
    {
      title: "User Count",
      field: "config.userCount",
      searchable: true,
      renderValue: renderConfigCell(null, 0),
    },
    {
      title: "Agent Count",
      field: "totalAgents",
      searchable: true,
      renderValue: renderConfigCell(totalAgents, 0),
    },
    {
      title: "Web Domain",
      field: "webUrl",
      searchable: true,
    },
    {
      title: "Edition",
      field: "config.license",
      searchable: true,
      renderValue: renderConfigCell(null, ""),
    },
    {
      title: "Account created",
      field: "created",
      searchable: true,
      renderValue: renderDateCell,
    },
    {
      title: "Parent ID",
      field: "parentId",
      searchable: true,
    },
    {
      title: "Blumira ID",
      field: "id",
      searchable: true,
    },
  ];

  const handleDeleteDone = () => {
    gotoOrg({ payload, orgId: undefined });
  };

  if (props.orgId) {
    return (
      <OrganizationDetail
        props={props}
        orgId={props.orgId}
        orgs={orgs}
        ready={props.ready}
        orgsError={orgsError}
        timezones={timezones}
        currentUserId={currentUserId}
        user={user}
        handleDeleteDone={handleDeleteDone}
        roleConstants={roleConstants}
        locations={locations}
        routeToPage={routeToPage}
        superadmin={props.superadmin}
        isAdministeringOrg={props.isAdministeringOrg}
      />
    );
  }

  const handleClose = () => {
    setOpenForm(false);
    setIsSaving(false);
  };

  const handleSaveClick = async () => {
    setIsSaving(true);

    let existingUserJSON;

    // query for users with entered email
    await new User({ email: userModel.email }).read().then((user) => {
      if (user && user[0]) existingUserJSON = user[0];
    });

    selectedOrgModel
      .create()
      .then((createdOrg = {}) => {
        const orgObjectForUser = {
          created: createdOrg.created,
          id: createdOrg.id,
          name: createdOrg.name,
        };
        // after org creation we have necessary
        // data to successfully create first location
        locationModel.set({ orgId: createdOrg.id });
        locationModel.create().then((createdLocation = {}) => {
          let method = "create";

          // if this user exists, update instead of create
          if (existingUserJSON) {
            method = "update";
            userModel.set({ id: existingUserJSON.id });
          }

          // after location creation we have necessary
          // data to successfully create first user
          userModel.set({
            orgRoles: existingUserJSON
              ? [
                  ...existingUserJSON.orgRoles,
                  { orgId: orgObjectForUser.id, roleId: 10 },
                  { orgId: orgObjectForUser.id, roleId: 40 },
                ]
              : [
                  { orgId: orgObjectForUser.id, roleId: 10 },
                  { orgId: orgObjectForUser.id, roleId: 40 },
                ], // default to administrator, responder
            locations: existingUserJSON
              ? [
                  ...existingUserJSON.locations,
                  { orgId: createdOrg.id, id: createdLocation.id },
                ]
              : [{ orgId: createdOrg.id, id: createdLocation.id }],
          });
          userModel[method]().then(() => {
            props.reload();
            handleClose();
          });
        });
      })
      .catch((e) => {
        handleClose();
      });
  };

  const handleTableRowClick = (model) => {
    gotoOrg({ payload, orgId: model.id });
  };

  return (
    <div className="dashboard organizations-page">
      <div className="dashboard-table">
        <SimpleTable
          isNorthStar
          title="Organizations"
          data={props.orgs}
          isFetching={!props.ready}
          rowClick={handleTableRowClick}
          error={orgsError}
          columns={tableColumns}
          toolbarActions={[
            {
              icon: AddCircleIcon,
              tooltip: "Add New Organization",
              onClick: (event) => {
                setSelectedOrgModel(new Org());
                setLocationModel(new Location());
                setUserModel(new User({ orgRoles: [] })); // set empty list to clear log warnings for required prop
                setOpenForm(true);
              },
            },
          ]}
          actions={[
            {
              icon: DetailsIcon,
              tooltip: "Show/Edit Details",
              onClick: (event, model) => {
                gotoOrg({ payload, orgId: model.id });
              },
            },
          ]}
        />
      </div>
      <EditOrgDialog
        openForm={openForm}
        isSaving={isSaving}
        timezones={timezones}
        userModel={userModel}
        handleClose={handleClose}
        locationModel={locationModel}
        isSuperadmin={props.superadmin}
        selectedOrgModel={selectedOrgModel}
        handleSaveClick={() => handleSaveClick()}
        isAdministeringOrg={props.isAdministeringOrg}
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  const { error } = state.org.listOrgs;

  const roleConstants = roleConstantsSelector(state);

  const isAdministeringOrg =
    !!state.page?.payload?.orgId &&
    WILDCARD_ORG_ID === state.page.payload.orgId;

  return {
    orgsError: error,
    roleConstants,
    user: state.session.settings.user,
    isAdministeringOrg: isAdministeringOrg,
    sessionOrgId: state.page.payload.orgId,
    currentUser: state.session.settings.user,
    currentUserId: state.session.settings.user.id,
    superadmin: state.session.settings.user.superadmin,
    timezones: state.session.settings.accountConstants.timezones,
    orgId: state.location.payload.id1,
    payload: state.location.payload,
  };
};

const mapDispatchToProps = (dispatch) => ({
  reload: (force) => dispatch(loadPageData(force)),
  gotoOrg: ({ payload, orgId }) => {
    dispatch(
      pageWithPayloadAndQuery({
        payload: { ...payload, id1: orgId },
        query: {},
      })
    );
  },
});

OrganizationsPageView.propTypes = {
  orgs: PropTypes.array,
  payload: PropTypes.shape({}),
};

OrganizationsPageView.defaultProps = {
  orgs: [],
  orgsError: null,
  payload: { toplevel: "settings", secondlevel: "organizations" },
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrganizationsPageView);
